import Image from "next/image";
import feature_item_1 from "/public/images/feature-item-1.png";
import feature_item_2 from "/public/images/feature-item-2.png";
import check from "/public/images/icon/check.png";
import notification from "/public/images/icon/notification.png";
import sheled from "/public/images/icon/sheled.png";

const Features = () => {
  return (
    <>
      <section className="features-section">
        <div className="overlay pt-120">
          <div className="container wow fadeInUp">
            <div className="row">
              <div className="col-lg-6">
                <div className="top-section">
                  <span className="head-icon d-flex justify-content-center align-items-center">
                    <Image src={sheled} alt="icon" />
                  </span>
                  <h5 className="sub-title">Informasi kurs harian</h5>
                  <h4 className="title">Kurs kompetitif</h4>
                  <p>
                    Kami memahami bahwa kebutuhan akan mata uang asing dapat muncul kapan saja, terutama bagi Anda yang sering bepergian ke luar negeri atau menjalankan bisnis internasional. Oleh karena itu, kami menyediakan layanan penukaran uang dengan kurs kompetitif dan proses yang sederhana. Anda tidak perlu khawatir mengenai keamanan, karena seluruh transaksi dilakukan dengan standar operasional yang ketat dan transparan. Selain itu, lokasi kami yang strategis memudahkan Anda untuk datang dan melakukan penukaran dengan nyaman. Kami juga menyediakan informasi kurs harian yang dapat diakses secara online, sehingga Anda bisa memantau nilai tukar sebelum melakukan transaksi.
                  </p>
                  <ul className="list">
                    <li className="list-item d-flex align-items-center">
                      <span className="check d-flex align-items-center justify-content-center">
                        <Image src={check} alt="icon" />
                      </span>
                      <span>Nilai tukar terbaik</span>
                    </li>
                    <li className="list-item d-flex align-items-center ">
                      <span className="check d-flex align-items-center justify-content-center">
                        <Image src={check} alt="icon" />
                      </span>
                      <span>Lokasi strategis</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-6 text-end">
                <div className="img-area">
                  <Image src={feature_item_1} alt="image" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-section second">
        <div className="overlay pt-120 pb-120">
          <div className="container wow fadeInUp">
            <div className="row">
              <div className="col-lg-6 text-start cus-ord">
                <div className="img-area">
                  <Image src={feature_item_2} alt="image" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="top-section">
                  <span className="head-icon d-flex justify-content-center align-items-center">
                    <Image src={notification} alt="icon" />
                  </span>
                  <h5 className="sub-title">Terpercaya</h5>
                  <h4 className="title">Aman, cepat, dan transparan</h4>
                  <p>
                    Sebagai penyedia layanan penukaran valuta asing yang terpercaya, kami berkomitmen untuk memberikan pengalaman transaksi yang aman, cepat, dan transparan bagi setiap pelanggan. Dengan kurs yang selalu diperbarui sesuai kondisi pasar, kami memastikan Anda mendapatkan nilai tukar terbaik untuk berbagai mata uang populer seperti USD, EUR, SGD, JPY, dan lainnya. Didukung oleh tim profesional yang ramah dan berpengalaman, kami hadir untuk memenuhi kebutuhan finansial Anda, baik untuk perjalanan bisnis, liburan, maupun keperluan pribadi. Kepercayaan pelanggan adalah prioritas kami, sehingga setiap transaksi selalu dilengkapi dengan bukti resmi dan sesuai regulasi yang berlaku.
                  </p>
                  <ul className="list">
                    <li className="list-item d-flex align-items-center">
                      <span className="check d-flex align-items-center justify-content-center">
                        <Image src={check} alt="icon" />
                      </span>
                      <span>Sesuai Regulasi yang berlaku</span>
                    </li>
                    <li className="list-item d-flex align-items-center ">
                      <span className="check d-flex align-items-center justify-content-center">
                        <Image src={check} alt="icon" />
                      </span>
                      <span>
                        Tim profesional yang ramah dan berpengalaman
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Features;
